import { ip_back } from "../config";

function authHeaders() {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  return token
    ? { Authorization: token, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

/**
 * One table-camera frame. The server matches OSNet-AIN torso embeddings
 * against the session gallery and may update seating.
 */
export async function identifyTablePlayers({
  frameJpeg,
  teId,
  tsId,
  tableNumber = null,
  tableId = null,
  checkpoint = "exercise",
  viewSetup = null,
  videoSize = null,
  signal,
}) {
  const body = {
    te_id: teId,
    ts_id: tsId,
    checkpoint: checkpoint === "eval" ? "eval" : "exercise",
    frame_jpeg: frameJpeg,
  };
  if (tableId) body.table_id = tableId;
  const num = Number(tableNumber);
  if (Number.isFinite(num) && num > 0) body.table_number = num;
  if (viewSetup) body.view_setup = viewSetup;
  const w = Number(videoSize?.w || videoSize?.width || 0);
  const h = Number(videoSize?.h || videoSize?.height || 0);
  if (w > 0) body.video_width = Math.round(w);
  if (h > 0) body.video_height = Math.round(h);

  const resp = await fetch(`${ip_back}api/mobileAPI/pose/identify-players`, {
    method: "POST",
    headers: authHeaders(),
    signal,
    body: JSON.stringify(body),
  });
  let json = {};
  try {
    json = await resp.json();
  } catch {
    json = {};
  }
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Player identity failed");
  }
  return json.data || null;
}
